module.exports = __webpack_public_path__ + "img/windDirection.a6f29fe2.svg";